var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6C22 3.79086 20.2091 2 18 2H6C3.79086 2 2 3.79086 2 6V11.25H22V6ZM22 12.75H2V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V12.75ZM18 4.25C18.4142 4.25 18.75 4.58579 18.75 5V7C18.75 7.41421 18.4142 7.75 18 7.75C17.5858 7.75 17.25 7.41421 17.25 7V5C17.25 4.58579 17.5858 4.25 18 4.25ZM14.75 5C14.75 4.58579 14.4142 4.25 14 4.25C13.5858 4.25 13.25 4.58579 13.25 5V7C13.25 7.41421 13.5858 7.75 14 7.75C14.4142 7.75 14.75 7.41421 14.75 7V5ZM18 15.25C18.4142 15.25 18.75 15.5858 18.75 16V18C18.75 18.4142 18.4142 18.75 18 18.75C17.5858 18.75 17.25 18.4142 17.25 18V16C17.25 15.5858 17.5858 15.25 18 15.25ZM14.75 16C14.75 15.5858 14.4142 15.25 14 15.25C13.5858 15.25 13.25 15.5858 13.25 16V18C13.25 18.4142 13.5858 18.75 14 18.75C14.4142 18.75 14.75 18.4142 14.75 18V16Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobots);
export default __webpack_public_path__ + "static/media/robots.d575b96e655a2f961cb1ac432611d105.svg";
export { ForwardRef as ReactComponent };